<script>
export default {
  props: ['link', 'type'],
  data() {
    return {
      input: this.link,
      socialists: {
        facebook: [
          'https://facebook.com/',
          'https://www.facebook.com/',
          'http://facebook.com/',
          'http://www.facebook.com/'
        ],
        twitter: [
          'https://twitter.com/',
          'https://www.twitter.com/',
          'http://twitter.com/',
          'http://www.twitter.com/'
        ],
        instagram: [
          'https://instagram.com/',
          'https://www.instagram.com/',
          'http://instagram.com/',
          'http://www.instagram.com/'
        ],
        yelp: [
          'https://yelp.com/',
          'https://www.yelp.com/',
          'http://yelp.com/',
          'http://www.yelp.com/'
        ]
      }
    }
  },
  model: {
    prop: 'link'
  },
  computed: {
    handle() {
      let handle = this.input
      this.socialists[this.type].forEach(url => {
        if (handle.startsWith(url)) {
          handle = handle.replace(url, '')
        }
      })
      if (handle.startsWith('@')) {
        handle = handle.replace('@', '')
      }
      if (handle.startsWith('/')) {
        handle = handle.replace('/', '')
      }
      return handle
    }
  },
  render() {
    return this.$scopedSlots.default({
     inputProps: {
       value: this.handle
     },
     inputEvents: {
       input: e => (this.input = e.target.value)
     }
    })
  }
}
</script>

